export const CHECKBOX_FILTERS = [
  {
    text: 'Hot',
    value: 'hasHot',
    selected: false,
  },
  {
    text: 'Rolled',
    value: 'hasRolled',
    selected: false,
  },
  {
    text: 'No Appt',
    value: 'noAppointmentTime',
    selected: false,
  },
  {
    text: 'Unconfirmed Appt',
    value: 'unconfirmedAppointment',
    selected: false,
  },
  {
    text: 'Claim',
    value: 'hasClaims',
    selected: false,
  },
  {
    text: 'Multi-Day',
    value: 'multiDay',
    selected: false,
  },
  {
    text: 'After Hours',
    value: 'afterHours',
    selected: false,
  },
  {
    text: 'No Options',
    value: 'hasOptions',
    selected: false,
  },
  {
    text: 'Drop Trailer',
    value: 'dropTrailer',
    selected: false,
  },
  {
    text: 'Backhaul Eligible',
    value: 'backhaulEligible',
    selected: false,
  },
  {
    text: 'Needs Tracking',
    value: 'needsTracking',
    selected: false,
  },
  {
    text: 'Needs Compliance Review',
    value: 'needsComplianceReview',
    selected: false,
  },
  {
    text: 'In Compliance Review',
    value: 'inComplianceReview',
    selected: false,
  },
]
